<template>
  <div class="modalUser">
    <b-modal @show="onOpen" id="modalCopyVendor" ref="modalCopyVendor" modal-class="modalsmall" centered>
      <template v-slot:modal-header>
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <h2 class="title text-uppercase">コピーベンダー</h2>
        </div>
      </template>
      <div class="modalUser--main">
        <b-form-group label="コピーするデータを選択します：">
          <b-form-checkbox
            stacked
            class="mb-2"
            v-model="copyData.company"
            @input="checkSelections"
            :value="true"
            :unchecked-value="false"
            name="copyData.company"
          > 業者のプロファイルをコピーする</b-form-checkbox>
          <b-form-checkbox
            stacked
            class="mb-2"
            v-model="copyData.users"
            @input="checkSelections"
            :value="true"
            :unchecked-value="false"
            name="copyData.users">
            業者の社員をコピーする
            <ul>
              <li>ユーザーのデフォルトのパスワードは `Abc@123456`に設定されています</li>
            </ul>
          </b-form-checkbox>
          <b-form-checkbox
            stacked
            v-model="copyData.attachments_folders"
            @input="checkSelections"
            :value="true"
            :unchecked-value="false"
            name="copyData.attachments_folders"
          > 業者のフォルダと添付ファイルをコピーします</b-form-checkbox>
        </b-form-group>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 button-group">
           <button
            @click.prevent="copy"
            :disabled="buttonDisabled"
            class="btn btn-rounder btn-success btn-login w-100"
            type="button">コピー</button>
        </div>
          <button
            @click.prevent="$bvModal.hide('modalCopyVendor')"
            class="btn btn-rounder btn-second btn-cancel w-100"
            type="button">キャンセル</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
export default {
  name: 'DeleteVendor',
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  props: {
    vendorId: null
  },
  data () {
    return {
      modalShow: false,
      companyID: null,
      buttonDisabled: false,
      copyData: {
        company: true,
        users: false,
        attachments_folders: false
      }
    }
  },
  methods: {
    onOpen () {
      this.copyData = {
        company: true,
        users: false,
        attachments_folders: false
      }
      this.buttonDisabled = false
    },
    checkSelections () {
      let selectedStatus = []
      for (var x in this.copyData) {
        if (this.copyData[x]) {
          selectedStatus.push(x)
        }
      }
      this.buttonDisabled = (selectedStatus.length === 0) || false
    },
    async copy () {
      try {
        await this.$store.dispatch('adminCompany/copyCompany', {id: this.companyID, copyData: this.copyData})
        this.$emit('copyResponse', true)
        setTimeout(() => {
          this.$bvModal.hide('modalCopyVendor')
        }, 500)
      } catch (error) { this.$emit('copyResponse', false) }
    }
  },
  watch: {
    vendorId (newVal, oldVal) {
      this.companyID = newVal
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Company/Copy.vue